export const getUser = () => {
  let user = localStorage.getItem("user");
  if (user) return JSON.parse(window.atob(user));
  else return false;
};

export const setUser = (user) => {
  let userLogin = {
    auth: user.auth,
    rol: user.rol,
  };

  localStorage.setItem("user", window.btoa(JSON.stringify(userLogin)));
};
